<template>
  <div class="goods">
    <Fontnavbar title="商品列表" />
    <backTop />

    <div class="container">
      <div class="banner" v-if="promotion && promotion.image">
        <van-image width="100%" :src="imgDomain + promotion.image" />
      </div>
      <div class="time" v-if="promotion && promotion.start_time">
        <span v-if="promotion.start_time > now" class="time-show">
          距开始
          <van-count-down :time="(promotion.start_time - now) * 1000" @finish="finish">
            <template #default="timeData">
              <span class="day">{{ timeData.days }}天</span>
              <span class="block">{{ timeData.hours }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.minutes }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.seconds }}</span>
            </template>
          </van-count-down>
        </span>
        <span v-if="promotion.start_time < now && promotion.end_time > now" class="time-show">
          距结束
          <van-count-down :time="(promotion.end_time - now) * 1000">
            <template #default="timeData">
              <span class="day">{{ timeData.days }} 天</span>
              <span class="block">{{ timeData.hours }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.minutes }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.seconds }}</span>
            </template>
          </van-count-down>
        </span>
      </div>
    </div>
    <!-- 商品列表 -->
    <div class="goods-tab goods-list-tab ">
    </div>
    <van-list v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="listLoad" style="padding-bottom: 50px;" v-if="goods.length > 0">
      <div>
        <!-- 样式2 -->
        <div class="goods-row">
          <div class="goods-row-item" v-for="(item,i) in goods" :key="i">
            <div class="row-item-img" @click="goPage('/goods/detail?id='+item.id)">
              <van-image width="100%" height="100%" :src="imgDomain + item.goods_thumb_path" />
            </div>
            <div class="row-item-detail" @click="goPage('/goods/detail?id='+item.id)">
              <div class="goods-title">{{ item.goods_name }}</div>
              <van-row type="flex" justify="space-between">
                <van-col span="8">
                  <div class="goods-price">￥{{ item.goods_price }}</div>
                  <del class="goods-shop_price">￥{{ item.user_price }}</del>
                </van-col>
                <van-col span="16">
                  <div v-if="promotion.start_time > now" class="cart-btn">
                    <div class="gray-btn-item">
                      {{promotion.start_date}}开抢
                    </div>
                  </div>
                  <div v-else class="cart-btn" @click.stop="addCart(item.id)">
                    <div class="cart-btn-item">
                      马上抢
                    </div>
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
        <!-- 页面加载 -->
        
      </div>
    </van-list>
    <div class="g-empty" v-else>
      <van-image width="100" height="80" src="/static/icon_emptyorder.png" />
      <p>暂无相关数据!</p>
    </div>

  </div>
</template>

<script>
import {
  Toast,
  Search,
  Icon,
  Row,
  Col,
  Image,
  Loading,
  List,
  CountDown
} from 'vant';
import { getPromotionList, addCart } from '../../api.js'
import Fontnavbar from "../../components/Navbar.vue";
import { post } from '../../request.js'
import backTop from "../../components/backTop.vue";
export default {
  components: {
    [Search.name]: Search,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Loading.name]: Loading,
    [Image.name]: Image,
    [List.name]: List,
    [CountDown.name]: CountDown,
    Fontnavbar,
    backTop
  },

  data() {
    return {
      imgDomain: process.env.VUE_APP_IMG_URL,
      loading: true,
      searchValue: '',
      goodsTap: 'is_new',
      orderNum: '',
      showType: 0,
      promotion: {},
      goods: [],
      page: 1,
      cateId: 0,
      brandId: 0,
      listLoading: false,
      finished: false,
      now:null,
    };
  },
  activated(){
    if(!this.$route.meta.isBack){
        // console.log('activated doing...')
      //加入页面初始化的逻辑
      this.cateId = this.$route.query.cate_id ? this.$route.query.cate_id : 0
      this.brandId = this.$route.query.brand_id ? this.$route.query.brand_id : 0
      this.searchValue = this.$route.query.keywords ? this.$route.query.keywords : ''
      this.page = 1
      this.getPromotionList()
    }
  },
  created() {
    // this.cateId = this.$route.query.cate_id ? this.$route.query.cate_id : 0
    // this.brandId = this.$route.query.brand_id ? this.$route.query.brand_id : 0
    // this.searchValue = this.$route.query.keywords ? this.$route.query.keywords : ''
    // this.getPromotionList()
  },
  methods: {
    // 获取商品列表
    getPromotionList() {
        // console.log('getPromotionList doing...')
      var that = this
      that.listLoading = true;
      var loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      });
      var postData = {
        page: that.page,
        id: this.$route.query.id,
        cate_id: that.cateId,
        brand_id: that.brandId,
        keywords: this.searchValue,
        updates: that.goodsTap == 'updates' ? 'desc' : '',
        sale: that.goodsTap == 'sale' ? 'desc' : '',
        price: that.goodsTap == 'price' ? that.orderNum : '',
      }
      post(getPromotionList, postData).then((res) => {
        that.listLoading = false
        loading.clear()
        if (res.code == 200) {
            that.promotion = res.data.promotion
            that.now = res.data.timestamp
          if (that.page == 1) {
            that.goods = res.data.goods_list
            that.goods = that.goods.sort(function (a, b) {
              return a.update_time < b.update_time ? 1 : -1
            });
            // console.log(this.$route.query)
          } else {
            that.goods = that.goods.concat(res.data.goods_list);
          }
          if (res.data.goods_list.length == 0) {
            this.finished = true
          }
        } else {
          Toast('网络错误');
        }
        ++that.page
      })
    },

    // 滚到底部加载
    listLoad() {
      // console.log("到底部了------------")
      this.getPromotionList();
    },  
    goPage(path) {
      this.$router.push({ path: path });
    },
    finish(){
      this.page = 1
      this.finished = false
      this.getPromotionList();
    },
    addCart(goods_id) {
      var loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      });
      post(addCart, { 'goods_id': goods_id, goods_num: 1 }).then((res) => {
        loading.clear()
        if (res.code == 200) {
          Toast.success('加入成功');
        } else {
          Toast(res.msg);
        }
      })
    }

  }
};
</script>

<style lang="less" scoped>
.goods {
  padding-bottom: 10px;
}
.goods-tab {
  margin-top: 5px;
  border-top: 1px #efefef solid;
}
.goods-list-tab {
  padding-left: 0;
}
.goods-tab-item {
  width: 20%;
  display: inline-block;
  text-align: center;
  font-size: 14px;
  color: #666666;
  vertical-align: top;
}
.goods-tab-item span {
  line-height: 40px;
  display: inline-block;
}
.goods-tab .on {
  border-bottom: 1px solid #ff465a;
  color: #ff465a;
}
.goods-type-icon {
  display: inline-block;
  margin-top: 12px;
  vertical-align: top;
}
.goods-show-type {
  margin-top: 6px;
}
.goods-clo-item {
  display: inline-block;
  width: 50%;
}
.goods-1 {
  padding: 10px 10px 0;
}
.goods-img {
  vertical-align: middle;
}
.goods-title {
  margin-top: 8px;
  font-size: 12px;
  line-height: 20px;
  color: #666666;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.goods-price {
  font-size: 14px;
  margin-top: 10px;
  color: #dd544e;
  font-weight: bolder;
}
.goods-shop_price{
  font-size: 10px;
  color: #888888;
}
.cart-btn {
  text-align: right;
}
.cart-btn-item {
  vertical-align: middle;
  display: inline-block;
  text-align: center;
  /*width: 24px;*/
  line-height: 22px;
  color: #ffffff;
  padding: 5px 15px;
  font-size: 12px;
  margin-top: 6px;
  border-radius: 3px;
  background-color: #dd544e;
}
.gray-btn-item {
  vertical-align: middle;
  display: inline-block;
  text-align: center;
  /*width: 24px;*/
  line-height: 24px;
  color: #ffffff;
  padding: 5px 15px;
  font-size: 12px;
  margin-top: 6px;
  border-radius: 3px;
  background-color: gray;
}
.padd-10 {
  padding-bottom: 20px;
}
.recon-title {
  text-align: center;
  font-size: 14px;
  color: #333333;
  padding: 15px;
}
.recon-goods {
  margin: 0 10px 5px 5px;
}
.recon-goods-item {
  width: 50%;
  display: inline-block;
}
.recon-goods-item-detail {
  margin-left: 5px;
  margin-bottom: 5px;
  background-color: #ffffff;
}
.goods-row-item {
  background-color: #ffffff;
  padding: 5px;
  margin-bottom: 5px;
}
.row-item-img {
  display: inline-block;
  width: 29%;
  margin-left: 1%;
  vertical-align: top;
  font-size: 0;
}
.row-item-detail {
  margin-left: 2%;
  margin-right: 1%;
  display: inline-block;
  vertical-align: top;
  width: 67%;
}



.time{
  font-weight: bolder;
  width: 100%;
  height: 60px;
  line-height: 60px;
  /*background: red;*/
  text-align: center;
  margin: 0 auto;

  .time-show{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.day{
  font-weight: bolder;
  font-size: 16px;
  margin-right: 10px;
}
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #dd544e;
}
.block {
  display: inline-block;
  width: 22px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #dd544e;
}
</style>
